import { featureFlagClient } from './core/featureFlagClient';
import type { FeatureFlagProvider } from './core/featureFlagClient.types';
import type {
  FeatureFlagKind,
  FeatureFlagValue,
  PortalFeatureFlagDefinition,
} from './featureFlagDefinition';

type AnyPortalFeatureFlagDefinition = PortalFeatureFlagDefinition<
  FeatureFlagProvider,
  FeatureFlagKind
>;

export function getFeatureFlagValue<Definition extends AnyPortalFeatureFlagDefinition>(
  definition: Definition,
  defaultValue: FeatureFlagValue<Definition>
): FeatureFlagValue<Definition> {
  switch (definition.kind) {
    case 'boolean':
      return featureFlagClient.getBooleanValue(definition.key, defaultValue as boolean, {
        provider: definition.provider,
      }) as FeatureFlagValue<Definition>;
    case 'string':
      return featureFlagClient.getStringValue(definition.key, defaultValue as string, {
        provider: definition.provider,
      }) as FeatureFlagValue<Definition>;
    case 'number':
      return featureFlagClient.getNumberValue(definition.key, defaultValue as number, {
        provider: definition.provider,
      }) as FeatureFlagValue<Definition>;
  }
}
